'use client';

import { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import { usePayment, useBooking, useEvent } from '@/store';
import useCallApiProcess from '../useCallApiProcess';
import { useTranslation } from 'react-i18next';
import useCheckoutPayment from './useCheckoutPayment';

export default function useCheckoutValidate3Ds() {
  const [isChallengeOk, setIsChallengeOk] = useState(false);
  const [isValidating, setIsValidating] = useState(false);

  const { t } = useTranslation();
  const router = useRouter();
  const { isInChallenge, changeIsInChallengeStatus } = usePayment();
  const {
    booking: { order },
  } = useBooking();
  const {
    event: { gateway },
  } = useEvent();

  const {
    checkPaymentStatus,
    verifyPaymentStatusResponse,
    confirmChallengeMut,
  } = useCheckoutPayment();

  const { showBackdrop, closeModal } = useCallApiProcess(
    null,
    t('checkout.loadings.processingPayment'),
  );

  /*
   * Confirm challenge
   * @param {string} challengeStatus - The status of the challenge 'completed' | 'aborting'
   *
   */
  const confirmChallenge = async (challengeStatus) => {
    setIsValidating(true);
    showBackdrop();
    await confirmChallengeMut({
      challengeStatus,
      id: router.query.order || order,
      gateway,
    });

    // make a long pulling with challenge evaluation rules
    const payment = await checkPaymentStatus(true); // => completed | notCompleted | need3dsChallenge | 3dsNotCompletedOrFailed

    if (payment.status === 'complete') {
      setIsChallengeOk(true);
    } else {
      setIsChallengeOk(false);
    }

    closeModal();
    setIsValidating(false);
    changeIsInChallengeStatus(false);
    verifyPaymentStatusResponse(payment, 'onConfirm', challengeStatus);
  };

  return {
    confirmChallenge,
    isChallengeOk,
    setIsValidating,
    isValidating,
    isInChallenge,
  };
}
